// Delete Smart Group
export const DELETE_SMART_GROUP_REQUEST = 'DELETE_SMART_GROUP_REQUEST';
export const DELETE_SMART_GROUP_DONE = 'DELETE_SMART_GROUP_DONE';
export const DELETE_SMART_GROUP_FAILED = 'DELETE_SMART_GROUP_FAILED';
